import { Box, Card, Dialog, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { IBlockerView } from '../../../../services';
import { BlockerDetails } from './BlockerDetails';

interface IBlockerEventProps {
  firstTime: number;
  currentEvent: IBlockerView;
  hourHeight: number;
  maxLengthDescription: number;
  columnIndex: number;
  totalColumns: number;
  refetch: () => any;
  refetchBlockers: () => any;
}

export const BlockerEvent: React.FC<IBlockerEventProps> = ({
  firstTime,
  currentEvent,
  hourHeight,
  maxLengthDescription,
  columnIndex,
  totalColumns,
  refetch,
  refetchBlockers
}) => {
  const [openDialogEdit, setOpenDialogEdit] = useState(false);

  const calculateTop = () => {
    const [startHours, startMinutes] = currentEvent.startTime.split(':').map(Number);
    const totalStartMinutes = startHours * 60 + startMinutes;
    return ((totalStartMinutes / 60) - firstTime) * hourHeight;
  };

  const calculateHeight = () => {
    const [startHours, startMinutes] = currentEvent.startTime.split(':').map(Number);
    const [endHours, endMinutes] = currentEvent.endTime.split(':').map(Number);

    const totalStartMinutes = startHours * 60 + startMinutes;
    const totalEndMinutes = endHours * 60 + endMinutes;

    const totalMinutes = totalEndMinutes - totalStartMinutes;
    return (totalMinutes / 15) * (hourHeight / 4);
  };

  const top = calculateTop();
  const height = calculateHeight();

  const widthPct = 100 / totalColumns;
  const leftPct = widthPct * columnIndex;

  const title = `Bloqueado: ${currentEvent.reason} | ${currentEvent.employeeName} | ${currentEvent.startTime} às ${currentEvent.endTime}`;

  const shortTitle = title.length > maxLengthDescription
    ? `${title.substring(0, maxLengthDescription)}...`
    : title;

  return (
    <>
      <Tooltip title={title}>
        <Card
          key={currentEvent.id}
          onClick={() => setOpenDialogEdit(true)}
          sx={{
            position: 'absolute',
            top: `${top}px`,
            left: `calc(${leftPct}% + 2px)`,
            width: `calc(${widthPct}% - 4px)`,
            height: `${height - 2}px`,
            backgroundColor: 'rgba(211, 47, 47, 0.08)',
            border: '2px dashed rgba(211, 47, 47, 0.5)',
            borderRadius: '8px',
            overflow: 'hidden',
            zIndex: columnIndex,
            transition: 'all 0.2s ease-in-out',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: 'rgba(211, 47, 47, 0.15)',
              border: '2px dashed rgba(211, 47, 47, 0.8)'
            }
          }}
        >
          <Box
            height='100%'
            padding={0.5}
            paddingLeft={1}
          >
            <Typography variant='body2' color='error'>{shortTitle}</Typography>
          </Box>
        </Card>
      </Tooltip>

      <Dialog
        open={openDialogEdit}
        onClose={() => setOpenDialogEdit(false)}
      >
        <BlockerDetails
          blocker={currentEvent}
          refetch={refetch}
          refetchBlockers={refetchBlockers}
          onClose={() => setOpenDialogEdit(false)}
        />
      </Dialog>
    </>
  );
};

